import "./AddComponentDialog.scss";
import Dialog from "../../../dialogs/Dialog";
import { useState, useRef } from "react";
import Input from "../../../forms/Input";
import DropDownList from "../../../forms/DropDownList";


export default function FieldDialog({ setOpen, isOpen, setBuildArea, rowI, colI, fieldI, field }) {
    const formRef = useRef(null);

    const [customClass, setCustomClass] = useState(field.customClass ? field.customClass : '');
    const [customWidth, setCustomWidth] = useState(field.customWidth ? field.customWidth : 'auto');

    const detailOptions = [
        { value: "detail-small", label: "Malá (30%)" },
        { value: "auto", label: "Automatická" },
        { value: "detail-large", label: "Veľká (70%)" }
    ];

    const handleClose = () => {
        setCustomClass("");
        setCustomWidth("auto");
        setOpen(false);
    }

    const editField = () => {
        setBuildArea(prev =>
            prev.map((row, rI) => {
                if (rI !== rowI) return row;
                return {
                    ...row,
                    data: row.data.map((col, cI) => {
                        if (cI !== colI) return col;
                        return {
                            ...col,
                            data: col.data.map((f, fI) => {
                                if (fI !== fieldI) return f;
                                return { ...field, customClass, customWidth };
                            }),
                        };
                    }),
                };
            })
        );
    };

    const handleSave = (e) => {
        e.preventDefault();
        editField();
        handleClose();
    };

    const handleConfirm = () => formRef.current?.requestSubmit();

    return (
        <Dialog
            title={"Nastavenia komponentu"}
            isOpen={isOpen}
            onClose={handleClose}
            onConfirm={handleConfirm}
            className={"AkcUiDesigner"}
            level={1}
            width={window.innerWidth / 3}>
            <form ref={formRef} onSubmit={handleSave}>
                <div className="add-dialog-body">
                    <div className="form-group">
                        <label htmlFor="customClass">Vlastná trieda</label>
                        <Input
                            name="customClassInput"
                            type="text"
                            className={"add-dialog-form-control"}
                            id="customClass"
                            placeholder="Zadajte názov vlastnej triedy"
                            value={customClass}
                            onChange={(_, v) => setCustomClass(v)}
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="width">Šírka komponentu</label>
                        <DropDownList
                            name="componentWidth"
                            className="add-dialog-form-control"
                            id="width"
                            value={detailOptions.find(item => item.value === customWidth)}
                            onChange={(_, value) => setCustomWidth(value.value)}
                            data={detailOptions}
                            textField="label"
                            dataItemKey="value"
                        >
                        </DropDownList>
                    </div>
                </div>
            </form>
        </Dialog>
    )
}
